//* ------------------------------------*\
//    $CLASS NAMES - for class names
//      not CSS selectors
//* ------------------------------------*/

const CLASS_NAMES = {
  ABOVE_BOTTOM: 'above-bottom',
  ABOVE_HALFWAY: 'above-halfway',
  ABOVE_VIEWPORT: 'above-viewport',
  ACCORDION_CONTAINER: 'accordion-container',
  ACCORDION_ICON: 'accordion-icon',
  ACCORDION_ITEM: 'accordion-item',
  ACCORDION_ITEM_JS: 'accordion-item-js',
  ACTIVE: 'active',
  BELOW_BOTTOM: 'below-bottom',
  BELOW_HALFWAY: 'below-halfway',
  BELOW_VIEWPORT: 'below-viewport',
  BLINK: 'blink',
  ERROR: 'error',
  CLICK: 'click',
  CLOSED: 'closed',
  CONTENT: 'content',
  DESKTOP_MENU_DROPDOWN: 'navigation-bar__desktop-menu-item-dropdown',
  DESKTOP_MENU_ITEM: 'navigation-bar__desktop-menu-item',
  FADE: 'fade',
  FILTER_SELECTED: 'filter-selected',
  FIRST_BATCH: 'first-batch',
  FIXED: 'fixed',
  FILTERED: 'filtered',
  HAMBUGER: 'hambuger',
  HEADER: 'header',
  HIDE: 'hide',
  HIDING: 'hiding',
  HIDDEN: 'hidden',
  HOVER: 'hover',
  ICON: 'icon',
  IN_VIEWPORT: 'in-viewport',
  IS_ACTIVE: 'is-active',
  IS_COMPLETE: 'is-complete',
  JOBS_APPLY_FILTERS: 'jobs-sidebar-filters__facetwp-apply',
  JOBS_SELECT_FILTERS: 'jobs-listing__select-filters',
  JOBS_SIDEBAR_FILTERS: 'jobs-sidebar-filters',
  LINK: 'link',
  LISTING_FILTERS: 'listing-filters',
  LOADING: 'loading',
  MENU: 'menu',
  MINI: 'mini',
  NAV_CHILD: 'nav-child',
  NAV_DESKTOP: '.navigation-bar__desktop-menu',
  NEXT: 'next',
  OPEN: 'open',
  OPENED: 'opened',
  PREV: 'prev',
  RESEARCH_APPLY_FILTERS: 'research-sidebar-filters__facetwp-apply',
  RESEARCH_SELECT_FILTERS: 'research-filters__select-filters',
  RESEARCH_SIDEBAR_FILTERS: 'research-sidebar-filters',
  SCROLLED: 'scrolled',
  SEARCH: 'search',
  SEARCHING: 'searching',
  SELECTED: 'selected',
  SHOW: 'show',
  SUB_MENU: 'sub-menu',
  SUCCESS: 'success',
  SWIPER: 'swiper',
  SWIPER_BTN: 'featured-jobs-carousel__swiper__btn',
  TAB: 'tab',
  TAB_PANEL: 'tab-panel',
  TABS_PROGRESS_STEP: 'tabs__progress-step',
  TIER_SELECTION_CONTENT: 'tier-selection-content',
  VISUALLY_HIDDEN: 'visually-hidden'
};

export default CLASS_NAMES;
